import { State } from '../constants/state';

export class ServiceError extends Error {
  constructor(
    readonly title: string = 'Failed to sign in',
    readonly message: string = 'This session appears to have expired, please sign in again from your IDE',
    readonly state: State = State.Error
  ) {
    super(message);
  }
}
